export function isLoading(data) {
  const loading = {
    ...this.state.loading,
    isLoading: data,
  };
  this.setState({ loading });
}
